import { createSlice } from "@reduxjs/toolkit";
import { Token } from "../interface/Token";

const initialState: Token | null = null;

const tokenTPSlice = createSlice({
  name: "tokenTP",
  initialState,
  reducers: {
    setTokenInStore: (state, action) => {
      return action.payload;
    },
  },
});

export const { setTokenInStore } = tokenTPSlice.actions;

export default tokenTPSlice.reducer;